import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';

import * as rootReducer from 'app/core/store';
import { ModalWhatIsPpComponent } from '../../modals/modal-what-is-pp/modal-what-is-pp.component';
import { ModalsService } from '../../modals/modals.service';

@Component({
  standalone: false,
  selector: 'pptl-header-anonymous',
  templateUrl: 'header-anonymous.component.html',
  styleUrls: ['header-anonymous.component.scss', '../header.scss'],
})
export class HeaderAnonymousComponent {
  constructor(
    private store: Store<rootReducer.State>,
    private modalsService: ModalsService,
    private router: Router,
  ) {}

  goToPage(path: string) {
    if (path) {
      this.router.navigate([path]);
    }
  }

  async onWhatIsPpClick() {
    this.modalsService.showModal({
      component: ModalWhatIsPpComponent,
      cssClass: 'modal-what-is-pp',
      componentProps: {},
    });
  }
}
